import React from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemText,
  Button,
  Grid,
  Divider,
  Paper,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import PageTitle from "../../components/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import FeeService from "./Locality/Service/feeService";
import StudentService from "./Locality/Service/studentService";
import StudentCards from "./UserProfileCard";
import PaymentDetailsPage from "./PaymentDetailsPage";
import PaymentReceiptPage from "./PaymentReceiptPage";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ScheduleIcon from '@material-ui/icons/Schedule';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import SchoolIcon from '@material-ui/icons/School';
import PaymentIcon from '@material-ui/icons/Payment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f8fafc',
    minHeight: '100vh',
    fontFamily: '"Inter", "Roboto", sans-serif',
  },
  welcomeSection: {
    background: 'rgb(15, 59, 98)',
    borderRadius: '16px',
    padding: '32px',
    marginBottom: '24px',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  welcomeContent: {
    position: 'relative',
    zIndex: 1,
  },
  welcomeTitle: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '8px',
  },
  welcomeSubtitle: {
    fontSize: '14px',
    opacity: 0.9,
    fontWeight: '400',
  },
  studentCard: {
    marginBottom: '24px',
    borderRadius: '12px',
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
  },
  mainContent: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    border: '1px solid #e2e8f0',
  },
  academicYear: {
    fontSize: '22px',
    fontWeight: '600',
    color: 'rgb(15, 59, 98)',
    marginBottom: '24px',
    textAlign: 'center',
    padding: '12px 0',
    borderBottom: '2px solid rgb(15, 59, 98)',
  },
  feeOverview: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '12px',
    },
  },
  tuitionFeeCard: {
    background: '#f8fafc',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e2e8f0',
    borderLeft: '4px solid rgb(15, 59, 98)',
  },
  tuitionFeeLabel: {
    fontSize: '23px',
    fontWeight: '600',
    color: 'rgb(15, 59, 98)',
    marginBottom: '8px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  tuitionFeeAmount: {
    fontSize: '30px',
    fontWeight: '700',
    color: 'rgb(15, 59, 98)',
    marginBottom: '4px',
  },
  tuitionFeeSubtext: {
    fontSize: '13px',
    color: '#64748b',
  },
  paymentStatusCard: {
    background: '#f8fafc',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e2e8f0',
    borderLeft: '4px solid #10b981',
  },
  statusLabel: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#10b981',
    marginBottom: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  statusItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  statusItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: 'white',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
  },
  statusText: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
  },
  statusBadge: {
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  statusPaid: {
    backgroundColor: '#dcfce7',
    color: '#166534',
  },
  statusDue: {
    backgroundColor: '#fef2f2',
    color: '#dc2626',
  },
  paymentSchedule: {
    marginTop: '24px',
  },
  scheduleLabel: {
    fontSize: '18px',
    fontWeight: '600',
    color: 'rgb(15, 59, 98)',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '8px',
    borderBottom: '1px solid #e2e8f0',
  },
  scheduleTable: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    overflow: 'hidden',
    '@media (max-width: 768px)': {
      fontSize: '12px',
    },
  },
  tableHeader: {
    backgroundColor: '#f8fafc',
    '& th': {
      padding: '12px 8px',
      textAlign: 'center',
      fontWeight: '600',
      color: 'rgb(15, 59, 98)',
      borderBottom: '1px solid #e2e8f0',
      fontSize: '12px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      backgroundColor: '#f8fafc',
      '@media (max-width: 768px)': {
        padding: '8px 4px',
        fontSize: '10px',
      },
    },
  },
  tableRow: {
    '& td': {
      padding: '12px 8px',
      borderBottom: '1px solid #e2e8f0',
      fontSize: '13px',
      color: '#374151',
      backgroundColor: 'white',
      textAlign: 'center',
      '@media (max-width: 768px)': {
        padding: '8px 4px',
        fontSize: '11px',
      },
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  statusPaidCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    color: '#059669',
    fontWeight: '500',
    fontSize: '12px',
  },
  statusDueCell: {
    color: '#dc2626',
    fontWeight: '500',
    fontSize: '12px',
  },
  actionButtons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    marginTop: '40px',
    flexWrap: 'wrap',
  },
  invoiceButton: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    color: 'white',
    fontWeight: '600',
    padding: '16px 32px',
    borderRadius: '12px',
    textTransform: 'none',
    fontSize: '16px',
    boxShadow: '0 8px 24px rgba(59, 130, 246, 0.3)',
    border: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 32px rgba(59, 130, 246, 0.4)',
      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
    },
  },
  receiptButton: {
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    fontWeight: '600',
    padding: '16px 32px',
    borderRadius: '12px',
    textTransform: 'none',
    fontSize: '16px',
    boxShadow: '0 8px 24px rgba(16, 185, 129, 0.3)',
    border: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 32px rgba(16, 185, 129, 0.4)',
      background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
    },
  },
  notesSection: {
    marginTop: '24px',
    padding: '16px',
    background: '#fef3c7',
    borderRadius: '8px',
    border: '1px solid #f59e0b',
    borderLeft: '4px solid #f59e0b',
  },
  notesLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#92400e',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  noteItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    marginBottom: '8px',
    fontSize: '13px',
    color: '#92400e',
    lineHeight: '1.5',
  },
  footer: {
    textAlign: 'center',
    marginTop: '24px',
    padding: '16px',
    fontStyle: 'italic',
    color: '#64748b',
    fontSize: '12px',
    background: '#f8fafc',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
  },
  quickActions: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
    marginTop: '32px',
  },
  quickActionCard: {
    padding: '20px',
    borderRadius: '12px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: '2px solid transparent',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
    },
  },
  quickActionPrimary: {
    background: 'linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%)',
    '&:hover': {
      borderColor: '#8b5cf6',
    },
  },
  quickActionSecondary: {
    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
    '&:hover': {
      borderColor: '#3b82f6',
    },
  },
  invoiceList: {
    marginTop: '24px',
  },
  invoiceItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    marginBottom: '12px',
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: 'rgb(15, 59, 98)',
    },
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },
  },
  invoiceInfo: {
    flex: 1,
  },
  invoiceTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: 'rgb(15, 59, 98)',
    marginBottom: '4px',
  },
  invoiceDetails: {
    fontSize: '12px',
    color: '#64748b',
  },
  invoiceStatus: {
    marginLeft: '16px',
    '@media (max-width: 768px)': {
      marginLeft: '0',
      alignSelf: 'flex-end',
    },
  },
}));

export default function ParentFee() {
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [feeList, setFeeList] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedAcademicYear, setSelectedAcademicYear] = useState("");
  const [showPaymentPage, setShowPaymentPage] = useState(false);
  const [showReceiptPage, setShowReceiptPage] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(null);

  const formatINR = (v) => {
    const n = Number(v || 0);
    return Number.isFinite(n) ? `₹${n.toLocaleString()}` : "₹0";
  };

  const paidCount = invoices.filter((i) => i.status === "Paid").length;
  const dueCount = invoices.filter((i) => i.status !== "Paid").length;

  // Get current date info
  const currentDate = new Date();
  const dayOfMonth = currentDate.getDate();
  const monthName = currentDate.toLocaleString('en-US', { month: 'long' });
  const year = currentDate.getFullYear();
  const dayOfWeek = currentDate.toLocaleString('en-US', { weekday: 'long' });
  const weekNumber = Math.ceil((currentDate - new Date(currentDate.getFullYear(), 0, 1)) / (7 * 24 * 60 * 60 * 1000));
  const dayOfYear = Math.floor((currentDate - new Date(currentDate.getFullYear(), 0, 0)) / (24 * 60 * 60 * 1000));

  // Fetch children for logged-in user and preselect first child
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!userDetails._id) return;
    StudentService.findStudentList({ userId: userDetails._id })
      .then((res) => {
        const mappedStudents = res.map((student) => ({
          ...student,
          fullName: `${student.firstName} ${student.lastName}`,
        }));
        setStudentList(mappedStudents);
        if (mappedStudents.length > 0) {
          setSelectedStudent(mappedStudents[0]);
          if (mappedStudents[0]?.classId?.className) {
            setSelectedClassName(mappedStudents[0].classId.className);
          }
          getFeeList(mappedStudents[0]._id, mappedStudents[0].classId._id);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const handleStudentClick = (studentId, classId) => {
    const found = studentList.find((s) => s._id === studentId);
    setSelectedStudent(found || null);
    if (found?.classId?.className) setSelectedClassName(found.classId.className);
    getFeeList(studentId, classId);
  };

  const formatDateDMY = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (!Number.isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, '0');
      const monthName = d.toLocaleString('en-US', { month: 'long' });
      const yyyy = d.getFullYear();
      return `${dd} ${monthName} ${yyyy}`;
    }
    try {
      const [year, month, dayWithTime] = String(date).split("-");
      const day = (dayWithTime || '').slice(0, 2);
      const monthIndex = Math.max(0, (parseInt(month, 10) || 1) - 1);
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ];
      const monthName = monthNames[monthIndex] || '';
      return `${day} ${monthName} ${year}`;
    } catch (_) {
      return String(date);
    }
  };

  const getFeeList = (studentId, classId) => {
    FeeService.findFeeList({ studentId, classId })
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setFeeList(list);

        // Parent view should show a single fee structure (most recent / first result)
        const fee = list[0] || null;
        if (fee?.feeMasterId?.acadamicYear) {
          setSelectedAcademicYear(fee.feeMasterId.acadamicYear);
        }

        const installmentsRaw = Array.isArray(fee?.istallmentId) ? fee.istallmentId : [];
        // Sort by due date for consistent schedule
        const installments = [...installmentsRaw].sort((a, b) => {
          const da = a?.installmentdate ? new Date(a.installmentdate).getTime() : 0;
          const db = b?.installmentdate ? new Date(b.installmentdate).getTime() : 0;
          return da - db;
        });

        const built = installments.map((inst, idx) => {
          const date = inst.installmentdate ? formatDateDMY(inst.installmentdate) : "";
          const status = inst.paymentStatus === "Paid" ? "Paid" : "Due";
          return {
            label: `Installment ${idx + 1}`,
            amount: Number(inst.installmentFee || 0),
            date,
            status,
            statusColor: status === "Paid" ? "#4CAF50" : "#F44336",
            installmentId: inst._id,
          };
        });
        setInvoices(built);
      })
      .catch((err) => console.error(err));
  };

  const handleDueButtonClick = (installment) => {
    setSelectedInstallment(installment);
    setShowPaymentPage(true);
  };

  const handlePaymentSuccess = (installment) => {
    setInvoices(prevInvoices => 
      prevInvoices.map(inv => 
        inv === installment ? { ...inv, status: "Paid", statusColor: "#4CAF50" } : inv
      )
    );
    setShowPaymentPage(false);
    setSelectedInstallment(null);
  };

  const handleBackFromPayment = () => {
    setShowPaymentPage(false);
    setSelectedInstallment(null);
  };

  const handlePaidButtonClick = (installment) => {
    setSelectedInstallment(installment);
    setShowReceiptPage(true);
  };

  const handleBackFromReceipt = () => {
    setShowReceiptPage(false);
    setSelectedInstallment(null);
  };

  // Show payment page if selected
  if (showPaymentPage && selectedInstallment) {
    return (
      <PaymentDetailsPage
        student={selectedStudent}
        installment={selectedInstallment}
        onBack={handleBackFromPayment}
        onPaymentSuccess={handlePaymentSuccess}
      />
    );
  }

  // Show receipt page if selected
  if (showReceiptPage && selectedInstallment) {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    return (
      <PaymentReceiptPage
        student={{
          ...selectedStudent,
          schooleId: {
            schoolName: userDetails.schoolName || "Montessori School"
          }
        }}
        installment={selectedInstallment}
        paymentDetails={{
          receiptNumber: "CrayBach001299",
          billId: "CrayBach001299",
          amountPaid: selectedInstallment?.amount || 0,
          amountDue: 0,
          paymentMode: "EaseBuzz-UPI",
          referenceNumber: "E2506060H8E7CV",
          paidBy: "Rekha (Mother)",
          paymentDate: new Date(),
          updatedBy: "Rekha",
          updatedAt: new Date(),
        }}
        onBack={handleBackFromReceipt}
      />
    );
  }

  return (
    <div className={classes.container}>
      <PageTitle title='Fee Management' />

      {/* Welcome Section */}
    

       {/* Student Selection Card with Welcome */}
       {studentList.length >= 1 && (
         <Card className={classes.studentCard}>
           <Box style={{ padding: '24px' }}>
             {/* Welcome Header */}
             <Box style={{ 
               textAlign: 'left', 
               marginBottom: '20px',
               padding: '0',
               background: 'transparent'
             }}>
               <Typography style={{ 
                 fontSize: '18px', 
                 fontWeight: '600', 
                 marginBottom: '4px',
                 color: 'rgb(15, 59, 98)'
               }}>
                 Welcome to Fee Management
               </Typography>
               <Typography style={{ 
                 fontSize: '13px', 
                 color: '#64748b',
                 lineHeight: '1.4'
               }}>
                 Manage your child's school fees with ease and transparency
               </Typography>
             </Box>

             {/* Academic Year */}
             <Box style={{ 
               display: 'flex',
               justifyContent: 'space-between',
               alignItems: 'center',
               marginBottom: '20px',
               padding: '12px 16px',
               background: '#f8fafc',
               borderRadius: '6px',
               border: '1px solid #e2e8f0'
             }}>
               <Typography style={{ 
                 fontSize: '12px', 
                 fontWeight: '600', 
                 color: '#64748b',
                 textTransform: 'uppercase',
                 letterSpacing: '0.5px'
               }}>
                 Academic Year
               </Typography>
               <Typography style={{ 
                 fontSize: '14px', 
                 fontWeight: '600', 
                 color: 'rgb(15, 59, 98)'
               }}>
                 {selectedAcademicYear || '2025 - 2026'}
               </Typography>
             </Box>

             {/* Student Cards */}
             <StudentCards 
               studentList={studentList} 
               onStudentSelect={handleStudentClick}
               selectedStudentId={selectedStudent?._id}
             />
           </Box>
         </Card>
       )}
      {/* Main Content */}
      <Paper className={classes.mainContent}>

        {/* Fee Overview */}
        <Box className={classes.feeOverview}>
          <Box className={classes.tuitionFeeCard}>
            <Typography className={classes.tuitionFeeLabel}>
              TOTAL FEE
            </Typography>
            <Typography className={classes.tuitionFeeAmount}>
              {feeList.length ? `${Number(feeList[0].totalFee || 0).toLocaleString()}/-` : "0/-"}
            </Typography>
            <Typography className={classes.tuitionFeeSubtext}>
              Annual fee structure
            </Typography>
          </Box>

          <Box className={classes.tuitionFeeCard}>
            <Typography className={classes.tuitionFeeLabel}>
              FEE SUMMARY
            </Typography>
            <Box style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Box style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                <Typography className={classes.statusText}>Tuition</Typography>
                <Typography className={classes.statusText}>{formatINR(feeList?.[0]?.tuitionFee)}</Typography>
              </Box>
              <Box style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                <Typography className={classes.statusText}>Transportation</Typography>
                <Typography className={classes.statusText}>{formatINR(feeList?.[0]?.transportationFee)}</Typography>
              </Box>
              <Box style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                <Typography className={classes.statusText}>Food</Typography>
                <Typography className={classes.statusText}>{formatINR(feeList?.[0]?.foodFee)}</Typography>
              </Box>
              <Box style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                <Typography className={classes.statusText}>App</Typography>
                <Typography className={classes.statusText}>{formatINR(feeList?.[0]?.appFee)}</Typography>
              </Box>
            </Box>
          </Box>

          <Box className={classes.paymentStatusCard}>
            <Typography className={classes.statusLabel}>
              PAYMENT STATUS
            </Typography>
            <Box className={classes.statusItems}>
              <Box className={classes.statusItem}>
                <Typography className={classes.statusText}>Paid Installments</Typography>
                <Chip 
                  label={String(paidCount)} 
                  className={`${classes.statusBadge} ${classes.statusPaid}`}
                  size="small"
                />
              </Box>
              <Box className={classes.statusItem}>
                <Typography className={classes.statusText}>Pending Installments</Typography>
                <Chip 
                  label={String(dueCount)} 
                  className={`${classes.statusBadge} ${classes.statusDue}`}
                  size="small"
                />
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Additional Components */}
        <Box style={{ marginTop: 8, marginBottom: 18 }}>
          <Typography className={classes.scheduleLabel} style={{ borderBottom: "none", marginBottom: 12 }}>
            <InfoIcon /> ADDITIONAL COMPONENTS
          </Typography>
          {Array.isArray(feeList?.[0]?.feeComponents) && feeList[0].feeComponents.length > 0 ? (
            <Paper style={{ padding: 12, borderRadius: 8, border: "1px solid #e2e8f0" }}>
              <List dense style={{ padding: 0 }}>
                {feeList[0].feeComponents.map((c, idx) => (
                  <ListItem key={idx} style={{ paddingLeft: 8, paddingRight: 8 }}>
                    <ListItemText
                      primary={
                        <span style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                          <span style={{ fontWeight: 600, color: "#1e293b" }}>{c.name || "-"}</span>
                          <span style={{ fontWeight: 600, color: "#1e293b" }}>
                            {c.operation === "-" ? "-" : "+"} {formatINR(c.fee)}
                          </span>
                        </span>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          ) : (
            <Typography style={{ color: "#64748b", fontSize: 13 }}>No additional components.</Typography>
          )}
        </Box>

        {/* Payment Schedule */}
        <Box className={classes.paymentSchedule}>
          <Typography className={classes.scheduleLabel}>
            <SchoolIcon /> PAYMENT SCHEDULE
          </Typography>
          
          {invoices.length > 0 ? (
            <table className={classes.scheduleTable}>
              <thead className={classes.tableHeader}>
                <tr>
                  <th>TOTAL</th>
                  {invoices.map((_, index) => (
                    <th key={index}>INSTALLMENT {index + 1}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className={classes.tableRow}>
                  <td style={{ fontWeight: '600', color: '#1e293b' }}>
                    {(feeList.length && feeList[0]?.totalFee != null
                      ? Number(feeList[0].totalFee || 0)
                      : invoices.reduce((sum, invoice) => sum + (invoice.amount || 0), 0)
                    ).toLocaleString()}
                  </td>
                  {invoices.map((invoice, index) => (
                    <td key={index}>{invoice.amount?.toLocaleString() || '-'}</td>
                  ))}
                </tr>
                <tr className={classes.tableRow}>
                  <td style={{ fontWeight: '600', color: '#1e293b' }}>
                    {paidCount} / {invoices.length} Paid
                  </td>
                  {invoices.map((invoice, index) => (
                    <td key={index}>
                      {invoice.status === "Paid" ? (
                        <Box className={classes.statusPaidCell}>
                          <CheckCircleIcon fontSize="small" />
                          Paid
                        </Box>
                      ) : (
                        <Typography className={classes.statusDueCell}>Due</Typography>
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          ) : (
            <Typography style={{ color: "#64748b", fontSize: 13 }}>No installments found.</Typography>
          )}
        </Box>

        {/* Invoice List */}
        {invoices.length > 0 && (
          <Box className={classes.invoiceList}>
            <Typography className={classes.scheduleLabel}>
              <PaymentIcon /> INVOICES
            </Typography>
            <Typography variant="body2" color="text.secondary" style={{ marginBottom: '20px' }}>
              Child's current invoices are displayed here
            </Typography>
            
            {invoices.map((inv, i) => (
              <Box key={i} className={classes.invoiceItem}>
                <Box className={classes.invoiceInfo}>
                  <Typography className={classes.invoiceTitle}>
                    {inv.label} – INR {inv.amount?.toLocaleString()}
                  </Typography>
                  <Typography className={classes.invoiceDetails}>
                    {selectedStudent?.fullName ? selectedStudent.fullName + " | " : ""}
                    {selectedClassName || "Program"}
                    {selectedAcademicYear ? ` (${selectedAcademicYear})` : ""} | {inv.date}
                  </Typography>
                </Box>
                <Box className={classes.invoiceStatus}>
                  <Chip
                    label={inv.status}
                    style={{
                      backgroundColor: inv.statusColor,
                      color: "#fff",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                    onClick={inv.status === "Due" ? () => handleDueButtonClick(inv) : () => handlePaidButtonClick(inv)}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        )}

        {/* Action Buttons */}
        {/* <Box className={classes.actionButtons}>
          <Button 
            className={classes.invoiceButton} 
            startIcon={<ReceiptIcon />}
            onClick={() => window.print()}
          >
            DOWNLOAD INVOICE
          </Button>
          <Button 
            className={classes.receiptButton} 
            startIcon={<PaymentIcon />}
            onClick={() => {
              if (invoices.length > 0) {
                const paidInvoice = invoices.find(inv => inv.status === "Paid");
                if (paidInvoice) {
                  handlePaidButtonClick(paidInvoice);
                }
              }
            }}
          >
            VIEW RECEIPT
          </Button>
        </Box> */}

        {/* Notes Section */}
        <Box className={classes.notesSection}>
          <Typography className={classes.notesLabel}>
            <InfoIcon /> Notes
          </Typography>
          <Box className={classes.noteItem}>
            <Typography variant="body2">
              • Notification in receipt if the parent pays late then it should show late FEE 2000/-
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Footer */}
      <Box className={classes.footer}>
        <Typography variant="body2">
          "The Identity of one changes with how one perceives reality"
        </Typography>
      </Box>
    </div>
  );
}